export const limitString = (string = "", limit = 0) => {
  if (!string) {
    return string
  }
  let limitedString = string.substring(0, limit)
  if (string.length > limit) {
    limitedString += "..."
  }
  return limitedString
}
